/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Err_Qty_ExceedsInputs */

const vi_pdc_err_qty_exceeds = /** @type {(inputs: Pdc_Err_Qty_ExceedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng vượt tồn khả dụng`)
};

/**

* @param {Pdc_Err_Qty_ExceedsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_err_qty_exceeds = /** @type {((inputs?: Pdc_Err_Qty_ExceedsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Err_Qty_ExceedsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_err_qty_exceeds(inputs)
});